import DocumentsUploadedViewModel from "../components/documentsUploadedViewModel";
import { Router } from "@frui.ts/screens";

export const LicensePlateChangeDocumentsUploadedViewModelNavigationName = "license_plate_change_documents";

@Router.registerRoute({
  route: LicensePlateChangeDocumentsUploadedViewModelNavigationName,
  name: "license_plate_change_documents",
})
export default class LicensePlateChangeDocumentsUploadedViewModel extends DocumentsUploadedViewModel {}
